<template>
  <div>
    <BreadCrumb crumb="个人信息"></BreadCrumb>
    <div class="per_info">
        <el-form :model="PerInfoForm" status-icon :rules="rulesPerInfoForm" ref="PerInfoForm" label-width="100px">
          <el-form-item label="用户名：" prop="name">
            <el-input type="text" v-model="PerInfoForm.name" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="email">
            <el-input type="text" v-model="PerInfoForm.email" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input type="text" v-model="PerInfoForm.mobile" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('PerInfoForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </div>

  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import cons from '@/components/constant'

export default {
  name: 'PerInfo',
  data () {
    var validateUserName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('用户名不能为空!'));
        } else {
          var reUser = /^.{2,20}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('账号是2到20位数字、字母或下划线'));
          }
        }
    };
    var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('邮箱不能为空!'));
        } else {
          var rePhone = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
          if(rePhone.test(value))
          {
            callback()
          }else{
             callback(new Error('邮箱式不正确'));
          }
        }
    };
    var validateMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('手机号不能为空!'));
        } else {
          var rePhone = /^1[34578]\d{9}$/;
          if(rePhone.test(value))
          {
            callback()
          }else{
             callback(new Error('手机号格式不正确'));
          }
        }
    };

    return {
      PerInfoForm: {
        email: '',
        mobile: '',
        name: ''
      },

      rulesPerInfoForm:{
          name: [
              { validator: validateUserName, trigger: 'blur' }
          ],
          email: [
              { validator: validateEmail, trigger: 'blur' }
          ],
          mobile: [
              { validator: validateMobile, trigger: 'blur' }
          ]
        }
    }

  },
  components:{
    BreadCrumb,
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;

      this.axios.get(cons.apis + '/v1_0/administrators/'+localStorage.user_id, {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json'
      })
      .then(dat=>{
          // console.log(dat);
          this.PerInfoForm = dat.data.data;
      }).catch(err=>{
         console.log(err);
      });
    },
    submitForm(){
      let token = localStorage.token;

      this.axios.put(cons.apis + '/v1_0/administrators/'+localStorage.user_id, {
              "name": this.PerInfoForm.name,
              "mobile": this.PerInfoForm.mobile,
              "email": this.PerInfoForm.email
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          this.resetForm('PerInfoForm');
        }).catch(err=>{
          console.log(err.response);
        })
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.fnGetData(1);
    }
  }
}
</script>

<style scoped>
  .per_info {
    background: #fff;
    padding: 100px 200px;


  }
</style>



// WEBPACK FOOTER //
// src/components/pages/PerInfo.vue